import React, { useEffect, useRef, useState } from "react";
import { Link,useNavigate } from "react-router-dom";
import { Alert, Button, Container, Spinner, Table } from "react-bootstrap";
import ClientPickerModal from "../pickers/ClientPickerModal";
import api from "../../axiosConfig";

export default function Contracts() {
  const navigate=useNavigate();
  const [client,setClient]=useState(null),[picker,setPicker]=useState(false);
  const [checking,setChecking]=useState(false);
  const checkingRef=useRef(false);
  const generate=async()=>{
    if(checkingRef.current)return;
    checkingRef.current=true;setChecking(true);setError("");
    try {
      const clients=new Map();
      let skip=0,total;
      do {
        const {data:selection}=await api.get("/contor/contracte",{params:{skip,limit:100,client_id:client?.id}});
        total=selection.total;
        for(const c of selection.items)clients.set(c.client_id,{id:c.client_id,label:c.client});
        if(clients.size>1){setError("Facturarea se face pentru un singur client. Filtrați lista după client și apăsați din nou Generare facturi.");return;}
        if(!selection.items.length&&skip<total)throw new Error("Lista incompletă");
        skip+=100;
      }while(skip<total);
      if(!clients.size){setError("Nu există contracte de facturat în lista curentă.");return;}
      navigate("/contor/facturare-client",{state:{browse:{client:[...clients.values()][0]}}});
    }catch(e){setError("Nu s-a putut verifica lista clienților. Reîncercați facturarea.");}
    finally{checkingRef.current=false;setChecking(false);}
  };
  const [data, setData] = useState({ total: 0, items: [] });
  const [page, setPage] = useState(0);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let active = true;
    setLoading(true); setError("");
    api.get("/contor/contracte", { params: { skip: page * 20, limit: 20,client_id:client?.id } }).then(r => {
      if (active) setData(r.data);
    }).catch(e => { if (active) setError(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Nu s-au putut încărca contractele."); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [page,client]);
  return <Container className="py-4">
    <h2>Contracte CONTOR</h2>
    <Button onClick={generate} disabled={loading||checking||!data.total} className="mb-3 me-2">Generare facturi</Button><Button variant="outline-primary" className="mb-3 me-2" disabled={checking} onClick={()=>setPicker(true)}>{client?client.label:"Filtrează după client"}</Button>{client&&<Button variant="outline-secondary" className="mb-3" disabled={checking} onClick={()=>{setClient(null);setPage(0);}}>Toți clienții</Button>}<ClientPickerModal show={picker} onHide={()=>setPicker(false)} onPick={c=>{setClient(c);setPage(0);setPicker(false);}}/>
    <Alert variant="info">Selectați contractul pentru detalii. Pentru facturare, filtrați lista după un singur client.</Alert>
    {data.can_edit && <Button as={Link} to="/contor/contracte/new" className="mb-3">Adaugă contract</Button>}
    {error && <Alert variant="danger">{error}</Alert>}
    {loading ? <Spinner animation="border" /> : <Table responsive striped bordered hover size="sm"><thead><tr><th>Contract</th><th>Client</th><th>De la</th><th>Până la</th><th>Echipamente</th><th>Facturare</th><th>Observații</th></tr></thead><tbody>{data.items.map(c=><tr key={c.id}>
    <td><Link to={'/contor/contracte/edit/'+c.id}>{c.numar}</Link></td><td>{c.client}</td><td>{c.data_inceput}</td><td>{c.data_sfarsit||'—'}</td><td>{c.echipamente.length}</td><td>{c.cumulat?'Cumulată':'Detaliată'}{c.chirie_separata?' · chirie separată':''}</td><td>{c.observatii}</td>
    </tr>)}</tbody></Table>}
    {!loading && !error && !data.total && <p>Nu există contracte.</p>}
    {data.total > 20 && <div className="d-flex gap-2 align-items-center">
      <Button disabled={!page || loading || checking} onClick={() => setPage(page - 1)}>Înapoi</Button>
      <span>Pagina {page + 1}</span>
      <Button disabled={(page + 1) * 20 >= data.total || loading || checking} onClick={() => setPage(page + 1)}>Înainte</Button>
    </div>}
  </Container>;
}
